import { AfterViewInit, Component, EventEmitter, Input, Output, SimpleChanges } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';
import { NgxUiLoaderService } from 'ngx-ui-loader';
import { Utilities } from 'src/app/models/utilities';
import { AppCoreService } from 'src/app/services/app-core.service';
import { CustomerService } from 'src/app/services/customer.service';
import { GeoService } from 'src/app/services/geo.service';
import { ProductService } from 'src/app/services/products.service';
import { RateBandsService } from 'src/app/services/ratebands.service';
import { ChargesService } from 'src/app/services/system-config/charges/charges.service';
import { VendorService } from 'src/app/services/vendor.service';
import Swal from 'sweetalert2';

@Component({
    selector: 'app-chargeperiod',
    templateUrl: './chargeperiod.component.html',
    styleUrls: ['./chargeperiod.component.scss']
})
export class ChargeperiodComponent implements AfterViewInit {
    @Input() showPeriodModal: any;
    @Input() chargeDetailData: any;
    @Input() periodData: any;
    @Input() chargeTypeList: any[];
    @Input() chargeCategoriesList: any[];
    chargePeriodForm: FormGroup;
    isModelSubmitted = false;
    Id: number;
    vendorList: any;
    customerList: any;
    chargeBandList: any;
    context: any

    showRateBand = false;
    showCustomer = false;
    showVendor = false;
    currentDate: any;
    useEnterKey: any;
    constructor(
        private formBuilder: FormBuilder,
        private chargeService: ChargesService,
        private ngxLoaderService: NgxUiLoaderService,
        private geoService: GeoService,
        private vendorService: VendorService,
        private productService: ProductService,
        private chargeBandsService: RateBandsService,
        private customerService: CustomerService,
        public activeModal: NgbActiveModal,
        private utilities: Utilities,
        private appCoreService: AppCoreService

    ) { this.context = { componentParent: this } }

    ngOnInit(): void {
        this.currentDate = this.utilities.FormatDateWithTime().dateString;
        this.chargePeriodForm = this.formBuilder.group({
            ddlChargeType: [null],
            txtFromDate: [this.currentDate],
            txtToDate: [this.currentDate, Validators.required],
            ddlRateBand: [null],
            ddlCustomer: [null],
            ddlVendor: [null],

        });
        this.chargePeriodForm.get('ddlChargeType').disable();
        this.chargePeriodForm.get('txtFromDate').disable();
        this.getAllVendors();
        this.getAllRateBands();
        this.getAllCustomers();
        this.bindFields(this.periodData);

        // const userData = this.appCoreService.GetUserData();
        // this.useEnterKey = !userData.metaInfo.tabbasedtemplate;
    }

    ngAfterViewInit(): void {
        this.useEnterKey ? this.utilities.focusFirstElement(this.chargePeriodForm) : null;
    }

    bindFields(cell: any) {
        if (cell) {
            // console.log('cell in bind fields', cell);
            this.Id = cell.id;
            // console.log(cell);
            let chargeTypeId = this.chargeTypeList.find(x => x.id == cell.chargetypeid)?.id;
            this.chargePeriodForm.get('ddlChargeType').setValue(chargeTypeId);
            this.chargePeriodForm.get('txtFromDate').setValue(this.utilities.FormatDateWithTime(0, cell.fromdate).dateString);
            this.chargePeriodForm.get('txtToDate').setValue(this.utilities.FormatDateWithTime(0, cell.todate).dateString);
            this.showRateBand = false;
            this.showCustomer = false;
            this.showVendor = false;
            if (cell.chargebandid) {
                // console.log('under chargeband');
                this.chargePeriodForm.get('ddlRateBand').setValue(cell?.chargebandid);
                this.chargePeriodForm.get('ddlCustomer').reset();
                this.chargePeriodForm.get('ddlVendor').reset();
                this.showRateBand = true;
                this.showCustomer = false;
                this.showVendor = false;
                //set required fields
                this.chargePeriodForm.controls.ddlRateBand.setValidators([Validators.required]);
                this.chargePeriodForm.controls.ddlCustomer.clearValidators();
                this.chargePeriodForm.controls.ddlVendor.clearValidators();

            }
            else if (cell.customerid) {
                // console.log('under customer');
                this.chargePeriodForm.get('ddlCustomer').setValue(cell?.customerid);
                this.chargePeriodForm.get('ddlRateBand').reset();
                this.chargePeriodForm.get('ddlVendor').reset();
                this.showCustomer = true;
                this.showRateBand = false;
                this.showVendor = false;
                this.chargePeriodForm.controls.ddlCustomer.setValidators([Validators.required]);
                this.chargePeriodForm.controls.ddlRateBand.clearValidators();
                this.chargePeriodForm.controls.ddlVendor.clearValidators();

            }
            else if (cell.vendorid) {
                // console.log('under vendor');
                this.chargePeriodForm.get('ddlVendor').setValue(cell?.vendorid);
                this.chargePeriodForm.get('ddlRateBand').reset();
                this.chargePeriodForm.get('ddlCustomer').reset();
                this.showVendor = true;
                this.showCustomer = false;
                this.showRateBand = false;
                this.chargePeriodForm.controls.ddlVendor.setValidators([Validators.required]);
                this.chargePeriodForm.controls.ddlCustomer.clearValidators();
                this.chargePeriodForm.controls.ddlRateBand.clearValidators();
            }
            this.chargePeriodForm.controls.ddlVendor.updateValueAndValidity();
            this.chargePeriodForm.controls.ddlCustomer.updateValueAndValidity();
            this.chargePeriodForm.controls.ddlRateBand.updateValueAndValidity();
        }
    }

    updatePeriod() {
        this.isModelSubmitted = true;
        if (this.chargePeriodForm.valid) {
            const periodObj = {
                id: this.Id,
                todate: this.chargePeriodForm.controls.txtToDate.value,
                ratebandid: this.chargePeriodForm.controls.ddlRateBand.value,
                customer: this.chargePeriodForm.controls.ddlCustomer.value,
                vendorid: this.chargePeriodForm.controls.ddlVendor.value,
            }
            this.chargeService.UpdateChargePeriodById(periodObj).subscribe(res => {
                try {
                    // console.log(res);
                    if (res && res.success) {
                        this.activeModal.close('Save Click');
                        this.successDialog("Record Updated successfully");
                    }
                } catch (error) {

                }
            });
        }
    }

    async successDialog(msg?: any) {
        const success = await Swal.fire({
            titleText: 'Success',
            text: msg,
            icon: 'success',
            confirmButtonText: 'Ok',
            allowEscapeKey: false,
            allowOutsideClick: false
        })
        if (success.isConfirmed) {
            //   this.updated.emit();
            //   this.hide();
        }
    }

    getAllRateCategories() {
        // this.chargeService.GetAllRateCatagories('').subscribe(res => {
        //     try {
        //         if (res && res.success) {
        //             // console.log(res);
        //             this.chargeCategoryList = res.data;
        //         }    
        //     } catch (error) {

        //     }
        // })
    }

    getAllRateBands() {
        try {
            this.chargeBandsService.GetAll().subscribe((res) => {
                if (res && res.success) {
                    this.chargeBandList = res.data;
                }
            })
        } catch (error) {

        }
    }
    getAllCustomers() {
        this.customerService.GetAll({ scid: this.appCoreService.GetUserData().selectedServiceCenter }).subscribe((res) => {
            if (res && res.success) {
                this.customerList = res.data;
            }
        })
    }

    hide() {
        this.showPeriodModal = false;
        //   this.onClose.emit();
    }

    getAllVendors() {
        try {
            this.vendorService.GetAllList().subscribe((res) => {
                if (res && res.success) {
                    this.vendorList = res.data;
                }
            })
        } catch (error) {

        }
    }
}